import { connect } from 'react-redux';
import moment from 'moment';
import Summary from '../components/summary/Summary';
import { getAvailableAddons } from '../redux/actions/dinings';
import {
  breakfastType,
  getTimes,
  shouldFetchDining,
  getDiningColor,
  breakfastPage,
  dinnerPage,
  getIsAllowedToChangeDining,
} from '../utils';

const getDiningLabel = ({ arrivalDate: arrivalDateString, departureDate: departureDateString }) => {
  if (!arrivalDateString || !departureDateString) return 'EVERYDAY';

  const arrivalDate = moment(arrivalDateString);
  const departureDate = moment(departureDateString);
  const fromDate = arrivalDate.format('Do');
  const toDate = departureDate.format('Do MMMM');

  return `EVERYDAY · ${fromDate} - ${toDate}`;
};

const getDinings = (dinings, bookingSearch) => {
  const { bookedBreakfast, bookedDinner } = dinings;
  const bookedDinings = [bookedBreakfast, bookedDinner];
  return bookedDinings
    .filter(({ AddonCategory }) => !!AddonCategory)
    .map(({ AddonCategory = '', Addon = {} }) => {
      const name = AddonCategory === breakfastType ? 'BREAKFAST' : 'DINNER';
      const { comments = '', code } = Addon;
      const { startTime, endTime } = getTimes(comments);
      const time = `${startTime} - ${endTime}`;
      const color = getDiningColor(code);
      const redirectPath = AddonCategory === breakfastType ? breakfastPage : dinnerPage;
      const isAllowedToChangeDining = getIsAllowedToChangeDining(dinings, bookingSearch, AddonCategory);

      return { name, time, color, redirectPath, isDisabled: !isAllowedToChangeDining };
    });
};

const mapStateToProps = ({ bookingSearch, dinings, config }) => ({
  diningLabel: getDiningLabel(bookingSearch),
  dinings: getDinings(dinings, bookingSearch),
  resId: bookingSearch.resId,
  shouldFetchAvailableAddons: shouldFetchDining(dinings, bookingSearch, config),
});

const mapDispatchToProps = dispatch => ({
  getAvailableAddons: resId => dispatch(getAvailableAddons(resId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
